<div class="subpage">
  <div class="subpage__content">
    <div class="subpage__header">
      <mat-icon>find_in_page</mat-icon>
      <h3 class="subpage__title">Pagina niet gevonden</h3>
    </div>
  </div>
</div>
